/**
 * Croatian overrides for the tasks screens.
 *
 * Only what genuinely differs from Bosnian. Croatian is ijekavica too, so
 * nothing moves for the jat reflex — what changes is vocabulary: *sustav*,
 * *tvrtka*, *datoteka*, *sigurnost*, *tipka*, and borrowed verbs in -irati.
 *
 * An entry identical to its Bosnian base is a bug, not a no-op: i18n.test.ts
 * fails on one, because a line that changes nothing is a decision that was
 * reverted in bs.ts without anybody revisiting this file.
 */

import type { TasksSlice } from '../bs/tasks'

export const tasks: Partial<TasksSlice> = {
  // *dugme* is a button on a coat here; the one on a screen is a *tipka*.
  'tasks.empty.manager':
    'Ovdje su zadaci koji su dodijeljeni vama. Zadatak uvijek pripada nekoj prijavi — dodijelite ga tipkom „Novi zadatak” ili sa same prijave.',
  'tasks.empty.worker': 'Zadatke dodjeljuje nadležni s konkretne prijave.',

  // *odabrati* throughout, where Bosnian and Serbian both say *izabrati*.
  'tasks.new.submission.placeholder': 'Odaberite prijavu',
  'tasks.new.assignee.placeholder': 'Odaberite osobu',
  'tasks.new.description.placeholder':
    'Nije obvezno — što točno treba napraviti, koji su dijelovi potrebni.',

  // *stroj* rather than *mašina*, and the browser is a *preglednik* whose
  // *postavke* you *dopuštate* things in.
  'tasks.scan.subtitle':
    'Usmjerite kameru na naljepnicu na stroju. Prijava se otvara s već odabranim radnim centrom.',
  'tasks.scan.cameraBlocked':
    'Pristup kameri nije moguć. Dopustite kameru u postavkama preglednika ili odaberite radni centar ručno.',
  'tasks.scan.pickManually': 'Odaberi radni centar ručno',

  'tasks.scanner.cameraBlocked':
    'Pristup kameri nije moguć. Dopustite kameru u postavkama preglednika.',

  // *stroj*, in the gender it takes.
  'tasks.qr.otherPlantTitle': 'Stroj nije u vašim pogonima',
  'tasks.qr.otherPlant':
    'Ovaj stroj nije ni u jednom od pogona kojima imate pristup — ili naljepnica više ne vrijedi. Ako na njemu trebate nešto prijaviti, obratite se administratoru.',
}
